import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllCustomersService = (page = 1, limit = 10, search = "") => {
  return HTTP_CLIENT.get(
    `${Endpoint.customers.getAllCustomers}?page=${page}&limit=${limit}&search=${search}`
  );
};

export { GetAllCustomersService };
